module.exports = __webpack_public_path__ + "static/media/medicon_youtube.0e4df8a4.png";